/* eslint-disable no-unused-vars */
import AOS from 'aos';

export default {
  init() {
    // JavaScript to be fired on all pages
    AOS.init({
      disable: 'mobile',
      once: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
